module.exports = __webpack_public_path__ + "67ad7041.png";